var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.26408 6.66676C1.57529 6.41321 2.03769 6.45448 2.29687 6.75892C4.01035 8.77165 7.1184 11.2832 12 11.2832C16.8815 11.2832 19.9895 8.77167 21.703 6.75894C21.9622 6.4545 22.4246 6.41324 22.7358 6.66678C23.047 6.92033 23.0892 7.37267 22.83 7.67712C22.3016 8.29784 21.6469 8.96728 20.8577 9.60918C20.9001 9.65564 20.937 9.70831 20.9669 9.76671L22.9224 13.5927C23.1035 13.9471 22.9567 14.378 22.5945 14.5552C22.2322 14.7324 21.7917 14.5887 21.6106 14.2344L19.6856 10.468C18.4652 11.2695 16.9983 11.9596 15.2651 12.3571L16.1412 16.6424C16.2206 17.0309 15.9631 17.4088 15.5659 17.4865C15.1688 17.5642 14.7825 17.3123 14.703 16.9238L13.8209 12.6092C13.2402 12.6799 12.6334 12.7179 12 12.7179C11.3665 12.7179 10.7597 12.6799 10.1789 12.6092L9.29684 16.9238C9.21741 17.3123 8.83107 17.5642 8.43393 17.4865C8.03679 17.4088 7.77924 17.0309 7.85866 16.6424L8.73478 12.357C7.30485 12.0291 6.0562 11.502 4.97768 10.8775L2.32003 14.344C2.07703 14.6609 1.61738 14.7252 1.29337 14.4875C0.96937 14.2497 0.903705 13.8001 1.14671 13.4831L3.75501 10.081C2.6858 9.30268 1.8295 8.45193 1.16987 7.6771C0.910686 7.37265 0.952866 6.92031 1.26408 6.66676Z",
    fill: "#898A8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.3475503d8f130b12c5f5dd772cbe2c09.svg";
export { ForwardRef as ReactComponent };